export default "__VITE_ASSET__Alu7jC_x__"